{
  "appName": "Planetra",
  "loading": "Loading",
  "actions": {
    "cancel": "Cancel",
    "close": "Close",
    "goToProjects": "Back to projects",
    "reload": "Reload the page",
    "retry": "Try again",
    "save": "Save"
  },
  "language": {
    "label": "Language",
    "en": "English",
    "ms": "Bahasa Melayu"
  },
  "realtime": {
    "live": "Live",
    "liveHint": "Run progress is updating as it happens.",
    "connecting": "Connecting",
    "connectingHint": "Opening the connection for live run progress.",
    "offline": "Not live",
    "offlineHint": "Live updates have stopped. Everything shown is still correct — it will refresh when the connection returns."
  },
  "severity": {
    "high": "High",
    "medium": "Medium",
    "low": "Low"
  },
  "skipToContent": "Skip to main content",
  "nav": {
    "label": "Main",
    "overview": "Overview",
    "projects": "All projects",
    "tools": "Tools",
    "workspace": "Map workspace",
    "dashboard": "Dashboard",
    "account": "Account and sessions"
  }
}
